import * as yup from 'yup';
import config from '../../config';

/** E-Mail validation */
export const email = yup.string().strict(true).trim().email().required();

/** File upload validation */
export const file = yup
  .mixed()
  .required()
  .test(
    'file-size',
    `file size exceeded maximum of ${config.data.upload.maxFileSize} bytes`,
    (fileList) =>
      fileList && fileList[0]?.size > 0 && fileList[0]?.size <= config.data.upload.maxFileSize
  )
  .test(
    'file-type',
    `file type must be one of "${config.data.upload.allowedMimeTypes.join(', ')}"`,
    (fileList) => fileList && config.data.upload.allowedMimeTypes.includes(fileList[0]?.type)
  );

/** Verification validation  */
export const isVerified = yup.bool().strict(true).required();

/** User's preferred language validation */
export const language = yup.string().strict(true).trim().oneOf(config.i18n.languages).required();

/** User's name validation */
export const name = yup.string().strict(true).trim().min(2).required();

/** Password validation */
export const password = yup.string().strict(true).matches(/.{6,}/).required();

/** Passwords must match */
export const passwordConfirmation = yup
  .string()
  .strict(true)
  .oneOf([yup.ref('password')])
  .required();

/** The analysis status (this is optional) */
export const status = yup.string().oneOf(['created', 'analyzing', 'done', 'error']);

/** Tags validation (array format) */
export const tags = yup.array().of(yup.string().strict(true).matches(/^\w+$/i));

/** Tags validation (string format) used within the form */
export const tagsString = yup.string().matches(/^[\w,\s]*$/gi);

/** UID validation */
export const uid = yup
  .string()
  .strict(true)
  .trim()
  .matches(/\w{16,}/) // seems to be 28 chars for users, 20 chars for documents
  .required();

/** Analysis' initial data validation */
export const analysisCreate = yup
  .object()
  .shape({
    name,
    tags,
  })
  .required();

/** Analysis' modifiable data validation */
export const analysisUpdate = yup
  .object()
  .shape({
    id: uid,
    pid: uid.notRequired(),
    status,
    name,
    tags,
  })
  .required();

/** SignUpUser data validation (used to create a new account) */
export const signUpUser = yup
  .object()
  .shape({
    name,
    email,
    password,
    language,
  })
  .required();

/** User/account validation */
export const user = yup
  .object()
  .shape({
    uid,
    name,
    email,
    language,
    isVerified,
  })
  .required();

export default {
  analysisCreate,
  analysisUpdate,
  email,
  language,
  name,
  password,
  passwordConfirmation,
  signUpUser,
  tags,
  tagsString,
  uid,
  user,
};
